import api from '@/utils/api';

/**
 * Get all customers
 * @param {string} query - Query to filter customers
 * @returns {Promise}
 */
const getCustomersApi = (query) => {
  const url = query ? `customer?${query}` : 'customer';
  return api.get(url);
};

export default getCustomersApi;
